import { Card, CardContent } from '@/components/ui/card'
import { Users, MapPin, Vote, TrendingUp } from 'lucide-react'
import type { NationKeyStats } from '@/lib/demographics'
import { formatPopulation } from '@/lib/demographics'

interface KeyStatsCardProps {
  stats: NationKeyStats
  className?: string
}

export function KeyStatsCard({ stats, className }: KeyStatsCardProps) {
  return (
    <div className={className}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <Users className="text-muted-foreground h-4 w-4" />
              <span className="text-muted-foreground text-sm">Population</span>
            </div>
            <div className="mt-1 text-2xl font-bold">
              {formatPopulation(stats.totalPopulation)}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <Users className="text-muted-foreground h-4 w-4" />
              <span className="text-muted-foreground text-sm">Cohorts</span>
            </div>
            <div className="mt-1 text-2xl font-bold">
              {stats.cohortCount.toLocaleString()}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <MapPin className="text-muted-foreground h-4 w-4" />
              <span className="text-muted-foreground text-sm">Regions</span>
            </div>
            <div className="mt-1 text-2xl font-bold">{stats.regionCount}</div>
            <div className="text-muted-foreground text-xs">
              {stats.districtCount} districts
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <Vote className="text-muted-foreground h-4 w-4" />
              <span className="text-muted-foreground text-sm">Avg Turnout</span>
            </div>
            <div className="mt-1 text-2xl font-bold">
              {Math.round(stats.averageBaseTurnout * 100)}%
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <TrendingUp className="text-muted-foreground h-4 w-4" />
              <span className="text-muted-foreground text-sm">Largest Group</span>
            </div>
            <div className="mt-1 text-lg font-bold">{stats.largestDemographic.value}</div>
            <div className="text-muted-foreground text-xs">
              {stats.largestDemographic.percentage}% of population
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <TrendingUp className="text-muted-foreground h-4 w-4" />
              <span className="text-muted-foreground text-sm">Top Issue</span>
            </div>
            <div className="mt-1 text-lg font-bold">{stats.mostSalientIssue.label}</div>
            <div className="text-muted-foreground text-xs">
              Salience: {(stats.mostSalientIssue.value * 100).toFixed(0)}%
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
